export default "__VITE_ASSET__8cYld5W2__"